import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetWorkflowsQueryVariables = Types.Exact<{
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type GetWorkflowsQuery = {
  __typename?: 'Query';
  workflows: {
    __typename?: 'WorkflowConnection';
    totalCount: number;
    edges: Array<{
      __typename?: 'WorkflowEdge';
      cursor: string;
      node: {
        __typename?: 'Workflow';
        id: any;
        name: string;
        description?: string | null;
        version: number;
        enabled: boolean;
        updatedAt: any;
        createdAt: any;
      };
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      hasPreviousPage: boolean;
      hasNextPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
  };
};

export const GetWorkflowsDocument = gql`
  query GetWorkflows($after: String, $before: String, $first: Int, $last: Int) {
    workflows(after: $after, before: $before, first: $first, last: $last) {
      totalCount
      edges {
        cursor
        node {
          id
          name
          description
          version
          enabled
          updatedAt
          createdAt
        }
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
    }
  }
`;

/**
 * __useGetWorkflowsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useGetWorkflowsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetWorkflowsQuery,
    GetWorkflowsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetWorkflowsQuery, GetWorkflowsQueryVariables>(
    GetWorkflowsDocument,
    options,
  );
}
export function useGetWorkflowsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkflowsQuery,
    GetWorkflowsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetWorkflowsQuery, GetWorkflowsQueryVariables>(
    GetWorkflowsDocument,
    options,
  );
}
export function useGetWorkflowsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkflowsQuery,
        GetWorkflowsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetWorkflowsQuery, GetWorkflowsQueryVariables>(
    GetWorkflowsDocument,
    options,
  );
}
export type GetWorkflowsQueryHookResult = ReturnType<
  typeof useGetWorkflowsQuery
>;
export type GetWorkflowsLazyQueryHookResult = ReturnType<
  typeof useGetWorkflowsLazyQuery
>;
export type GetWorkflowsSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkflowsSuspenseQuery
>;
export type GetWorkflowsQueryResult = Apollo.QueryResult<
  GetWorkflowsQuery,
  GetWorkflowsQueryVariables
>;
